export default {
    apiHost: process.env.REACT_APP_API_URI
}